import { ArticleParagraph1, IconWarningSign16 } from '@cian/ui-kit';
import { mergeStyles } from '@cian/utils';
import * as React from 'react';

import * as styles from './styles.css';

export interface IValuationNotFound {
  isDesktop: boolean;
}

export const ValuationNotFound: React.FC<IValuationNotFound> = ({ isDesktop }) => {
  return (
    <div {...mergeStyles(styles['container'], isDesktop ? styles['container_desktop'] : styles['container_mobile'])}>
      <div className={styles['image']}>
        <IconWarningSign16 />
      </div>
      <ArticleParagraph1>У нас пока нет оценки по этому адресу</ArticleParagraph1>
    </div>
  );
};

ValuationNotFound.displayName = 'ValuationNotFound';
